import axios from 'axios';
import router from '@/router';
import { baseURL } from '@/config';

// create an axios instance
const service = axios.create({
  baseURL, // url = base url + request url
  timeout: 5000 // request timeout
});

// 设置请求拦截器
service.interceptors.request.use(
  config => {
    console.log('请求拦截器生效', config.url); // for debug

    // 在请求发送前，将 token 设置到请求头中
    if (config.url === '/login' || config.url === '/register') {
      console.log('登录或注册请求，不添加 token');
      return config;
    } else {
      const token = sessionStorage.getItem('token') || ''  ;
      console.log('从 sessionStorage 获取 token:', token); // for debug

      if (token) {
        config.headers['token'] = token;
        console.log('token 已添加到请求头:', config.headers);
      } else {
        console.log('token 不存在，未添加到请求头');
      }

      return config;
    }
  },
  error => {
    console.error('请求拦截器错误:', error); // for debug
    return Promise.reject(error);
  }
);

// 设置响应拦截器
service.interceptors.response.use(
  response => {
    console.log('响应拦截器生效', response.status); // for debug
    const res = response.data;
    return res;
  },
  error => {
    console.error('响应拦截器错误:', error); // for debug
    return Promise.reject(error);
  }
);

export default service;